<template>
  <div class="page-container-summary">
    <LandingBarAdmin active="dashboard" />
    <div class="buy-wrapper">
      <div class="summary-upper">
        <div class="summary-left2">
          <div class="dashboard-left-top">
            <h1 class="table-headline">Current Market</h1>
            <v-btn depressed color="#59c26b" class="transfer-button">
              Buy/Sell</v-btn
            >
          </div>
          <div class="balance-flex2">
            <div class="balance2">
              <div class="summary-header">Request</div>
              <div class="dash-balance">
                300 <span class="offer-span">KWh</span>
              </div>
              <div class="dash-total">Total volume</div>
              <div class="dash-balance">
                50<span class="offer-span">&euro;</span> - 80<span
                  class="offer-span"
                  >&euro;</span
                >
              </div>
              <div class="dash-total">Price</div>
            </div>
            <div class="balance2">
              <div class="summary-header">Offer</div>
              <div class="dash-balance">
                200 <span class="offer-span">KWh</span>
              </div>
              <div class="dash-total">Total volume</div>
              <div class="dash-balance">
                33<span class="offer-span">&euro;</span> - 50<span
                  class="offer-span"
                  >&euro;</span
                >
              </div>
              <div class="dash-total">Price</div>
            </div>
          </div>
          <div class="summary-middle-table2 table-wrapper2">
            <div class="dashboard-right-top2 dash-head">
              <h1 class="table-headline">Current update</h1>
              <v-btn-toggle mandatory class="dash-toggle">
                <v-btn
                  color="#59c26b"
                  outlined
                  class="toggle-button"
                  :value="0"
                >
                  New offers
                </v-btn>
                <v-btn
                  color="#59c26b"
                  outlined
                  class="toggle-button"
                  :value="10"
                >
                  New requests
                </v-btn>
              </v-btn-toggle>
            </div>
            <table>
              <thead>
                <tr>
                  <th>DSO</th>
                  <th>Location</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Capacity (KWh)</th>
                  <th>Price (&euro;)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>DSO 1</td>
                  <td>Location 1</td>
                  <td>11/09/2021</td>
                  <td>09:23</td>
                  <td>54</td>
                  <td>54</td>
                </tr>
                <tr>
                  <td>DSO 2</td>
                  <td>Location 2</td>
                  <td>10/09/2021</td>
                  <td>13:35</td>
                  <td>20</td>
                  <td>20</td>
                </tr>
                <tr>
                  <td>DSO 3</td>
                  <td>Location 3</td>
                  <td>12/09/2021</td>
                  <td>06:30</td>
                  <td>28</td>
                  <td>28</td>
                </tr>
                <tr>
                  <td>DSO 4</td>
                  <td>Location 4</td>
                  <td>11/09/2021</td>
                  <td>14:45</td>
                  <td>60</td>
                  <td>60</td>
                </tr>
                <tr>
                  <td>DSO 5</td>
                  <td>Location 5</td>
                  <td>11/09/2021</td>
                  <td>21:25</td>
                  <td>30</td>
                  <td>30</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="summary-right2">
          <div class="dashboard-right-top dash-head">
            <h1 class="table-headline">Flex Market</h1>
            <v-btn-toggle mandatory class="dash-toggle">
              <v-btn color="#59c26b" outlined class="toggle-button" :value="0">
                Volume
              </v-btn>
              <v-btn color="#59c26b" outlined class="toggle-button" :value="10">
                Price
              </v-btn>
            </v-btn-toggle>
          </div>
          <div class="summary-graph">
            <DashboardLine />
          </div>
        </div>
      </div>
      <div class="summary-middle2"></div>
      <div class="dash-candle">
        <div class="dashboard-right-top dash-head">
          <h1 class="table-headline">Wholesale Market</h1>
          <v-btn-toggle mandatory class="dash-toggle">
            <v-btn color="#59c26b" outlined class="toggle-button" :value="0">
              Day ahead
            </v-btn>
            <v-btn color="#59c26b" outlined class="toggle-button" :value="10">
              Intra day
            </v-btn>
            <v-btn color="#59c26b" outlined class="toggle-button" :value="20">
              Balancing
            </v-btn>
          </v-btn-toggle>
        </div>
        <DashboardCandle />
      </div>
      <div class="headline-wrapper">
        <div class="headline-top">
          <h1 class="table-headline headline-headline">Headlines</h1>
          <div class="headline-subheader">Today, 9th September 2021</div>
        </div>
        <div class="headline-main">
          <div class="headline-left headline">
            <img src="../img/Headline1.png" alt="headline1" class="headline-img"/>
            <div class="headline-bold">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
            <div class="headline-text">
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s, when an unknown printer took a galley of type and
              scrambled
            </div>
          </div>
          <div class="headline-middle headline">
            <img src="../img/Headline2.png" alt="headline3" class="headline-img" />
            <div class="headline-bold">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
            <div class="headline-text">
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s, when an unknown printer took a galley of type and
              scrambled
            </div>
          </div>
          <div class="headline-right headline">
            <div class="headline-bold">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
            <div class="headline-text">
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s, when an unknown printer took a galley of type and
              scrambled
            </div>
            <img src="../img/Headline3.png" alt="headline3" class="headline-img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LandingBarAdmin from "../components/Common/LandingBarAdmin.vue";
import DashboardLine from "../components/Charts/DashboardLine";
import DashboardCandle from "../components/Charts/DashboardCandle";
import { mdiScaleBalance, mdiCurrencyEur, mdiRepeat } from "@mdi/js";

export default {
  components: { LandingBarAdmin, DashboardLine, DashboardCandle },
  data() {
    return {
      icons: {
        mdiScaleBalance,
        mdiCurrencyEur,
        mdiRepeat,
      },
      bread: [
        {
          text: "Portfolio Management",
          disabled: false,
        },
        {
          text: "Summary",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    selectAll() {
      let boxes = document.querySelectorAll("input");
      for (let box of boxes) {
        box.checked = true;
      }
    },
    userHistory() {
      this.Apps.userHistory();
    },
    offerHistory() {
      this.Apps.offerHistory();
    },
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.page-container-summary {
  min-height: 100vh;
  background: #f8fcff;
  padding-bottom: 50px;
  margin-top: -100px;
}

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.buy-wrapper {
  padding: 40px;
  background: #f8fcff;
}

.balance-flex2 {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.balance2 {
  display: flex;
  padding: 20px;
  position: relative;
  width: 47%;
  flex-direction: column;
  margin: 0 0 20px 0;
  border-radius: 10px;
  background: rgba(38, 56, 88, 1);
  background: -moz-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, rgba(38, 56, 88, 1)),
    color-stop(57%, rgba(38, 56, 88, 1)),
    color-stop(75%, rgba(71, 87, 115, 1)),
    color-stop(100%, rgba(153, 164, 180, 1))
  );
  background: -webkit-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -o-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -ms-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: linear-gradient(
    135deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#263858', endColorstr='#99a4b4', GradientType=1 );
}

.summary-icon {
  color: #fff !important;
  position: absolute !important;
  top: 20px !important;
  right: 20px !important;
}

.summary-header {
  color: #fff;
}

.dash-balance {
  margin: 20px 0 0 0;
  font-size: 34px;
  color: #fff;
  font-weight: 700;
}

.dash-total {
  margin-top: -10px;
  font-size: 16px;
  color: #fff;
}

.offer-span {
  font-size: 16px;
  font-weight: 400;
}

.conversion {
  font-size: 0.8em;
  color: #999;
}

.summary-upper {
  display: flex;
  justify-content: space-between;
}

.summary-left2,
.summary-right2 {
  width: 48%;
  display: flex;
  flex-direction: column;
}

.summary-right2 {
  background-color: #fff;
  flex: 1;
  margin-left: 50px;
}

.transfer-button {
  margin-bottom: 35px;
  margin-left: auto;
}

.transfer-button span {
  color: #fff;
  text-transform: none;
}

.summary-middle2 {
  display: flex;
  margin: 30px 0;
}

.summary-graph {
  flex: 1;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0);
  overflow-x: hidden;
}

.summary-middle-table2 {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 0;
  margin-top: 40px;
}

.summary-middle-table table {
  margin: 0;
}

.buy-wrapper table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

.table-wrapper2,
.dash-candle {
  background-color: #fff;
  padding: 20px;
}

.table-wrapper2 th {
  color: #979797;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.table-wrapper2 td {
  color: #000;
  font-size: 14px;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.transactions {
  width: 100%;
}

.table-headline2 {
  font-size: 22px;
  color: #000;
  margin-bottom: 20px;
}

.dashboard-left-top {
  display: flex;
  justify-content: space-between;
}

.dashboard-right-top {
  display: flex;
  align-content: center;
  margin-left: 20px;
}

.dashboard-right-top2 {
  display: flex;
  align-content: center;
}

// .dashboard-right-top .theme--light.v-btn--active:before, .theme--light.v-btn--active:hover:before {
//   opacity: 1 !important
// }

// .dashboard-right-top .theme--light.v-btn--active:before, .theme--light.v-btn--active span {
//   color: #fff !important;
// }

.dash-head .v-btn-toggle > .v-btn.v-btn--active {
  color: #fff !important;
  background-color: #59c26b !important;
  opacity: 1 !important;
}
.dash-head .v-btn-toggle {
  display: flex !important;
  justify-content: center;
  align-items: center;
  height: auto !important;
}

.dash-head .v-btn-toggle > .v-btn.v-btn {
  padding: 0 45px !important;
  border-width: 0 !important;
}

.dash-head
  .v-btn-toggle:not(.v-btn-toggle--dense)
  .v-btn.v-btn.v-size--default {
  height: 36px !important;
}

.dash-head .toggle-button > .v-btn__content {
  font-size: 14px;
  text-transform: none;
}
.dash-head .v-btn.v-btn--active > .v-btn__content .v-icon {
  color: #fff !important;
}

.dash-toggle {
  margin-left: 30px;
  margin-bottom: 20px;
}

.headline-wrapper {
  margin-top: 30px;
  padding: 20px;
}

.headline-subheader {
  color: #979797;
  font-size: 22px;
  margin-bottom: 20px
}

.headline-main {
  display: flex;
  justify-content: space-between;
}

.headline {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #fff
}

.headline-left {
  min-width: 45%
}

.headline-middle {
  min-width: 30%;
  margin: 0 50px;
}

.headline-right {
  min-width: 20%
}

.headline-img {
  width: 100%;
}

.headline-bold {
  font-weight: 700;
  font-size: 28px;
  padding: 20px;
}

.headline-text {
  font-size: 16px;
  padding: 0 20px 20px 20px;
  line-height: normal;
}

.headline-headline {
  margin-bottom: 0 !important
}
</style>
